import { all, takeEvery, put } from 'redux-saga/effects';

import { simpleRequestsLoader } from 'modules/app/utils';
import * as types from 'modules/releases/actionTypes';

import { deleteReleaseSuccess, fetchReleaseById } from '../actions/core';

/** @type {Record<string, import("modules/app/types").SimpleRequestConfig>} */
const simpleRequests = {
  [types.CREATE_RELEASE]: {
    notifications: {
      success: {
        id: 'page.releases.create.success',
        defaultMessage: 'The release note has been created successfully.',
      },
      failure: {
        id: 'page.releases.create.failure',
        defaultMessage: 'An error occurred while creating the release note.',
      },
    },
  },

  [types.UPDATE_RELEASE]: {
    notifications: {
      success: {
        id: 'page.releases.update.success',
        defaultMessage: 'The release note has been updated successfully.',
      },
      failure: {
        id: 'page.releases.update.failure',
        defaultMessage: 'An error occurred while updating the release note.',
      },
    },
  },

  [types.PATCH_RELEASE_STATE]: {
    notifications: {
      success: {
        id: 'page.releases.patchState.success',
        defaultMessage: 'The release state has been changed successfully.',
      },
      failure: {
        id: 'page.releases.patchState.failure',
        defaultMessage: 'An error occurred while changing the release state.',
      },
    },
  },

  [types.DELETE_RELEASE]: {
    callbacks: {
      success: (_, meta, requestAction) => deleteReleaseSuccess(requestAction.payload.releaseId, meta),
    },
    notifications: {
      success: {
        id: 'page.releases.delete.success',
        defaultMessage: 'The release has been deleted successfully.',
      },
      failure: {
        id: 'page.releases.delete.failure',
        defaultMessage: 'An error occurred while deleting the release.',
      },
    },
  },
};

/**
 * Intercepts modal opening to fetch fresh data when editing
 * @param {Object} action
 */
function* handleOpenCreationModal(action) {
  const { releaseId } = action.payload || {};

  if (releaseId) {
    yield put(fetchReleaseById(releaseId, { source: 'modal-edit' }));
  }
}

/**
 * Core releases saga
 */
export default function* coreReleasesSaga() {
  yield all(simpleRequestsLoader(simpleRequests));
  yield takeEvery(types.OPEN_CREATION_MODAL, handleOpenCreationModal);
}
